import Email from "@/domain/entities/emails/Email";
import { Editor } from "@tiptap/react";
import { createContext, ReactNode, useContext } from "react";

interface EditorContextType {
    editor: Editor | null;
    suggestionEditor: Editor | null;
    pendingSuggestion: boolean;
    setPendingSuggestion: (pendingSuggestion: boolean) => void;
    emailToReplyTo?: Email;
}

const EditorContext = createContext<EditorContextType | undefined>(undefined);

interface EditorProviderProps {
    children: ReactNode;
    value: EditorContextType;
}

export const EditorProvider = ({ children, value }: EditorProviderProps) => (
    <EditorContext.Provider value={value}>{children}</EditorContext.Provider>
);

export const useEditorContext = () => {
    const context = useContext(EditorContext);
    if (context === undefined) {
        throw new Error(
            "useEditorContext must be used within an EditorProvider",
        );
    }

    return context;
};
